import { TONE_COLOR_VAR } from './verdicts';
import './StageCard.css';

export default function StageCard({
  index,
  title,
  subtitle,
  weight,
  score,
  status,
  statusTone,
  rows,
  reasoning,
}) {
  const toneColor = TONE_COLOR_VAR[statusTone];

  return (
    <article className="stage-card">
      <header className="stage-card__header">
        <div className="stage-card__index">STAGE {index}</div>
        <div className="stage-card__status" style={{ color: toneColor, borderColor: toneColor }}>
          {status}
        </div>
      </header>

      <h3 className="stage-card__title">{title}</h3>
      <div className="stage-card__subtitle">{subtitle}</div>

      <div className="stage-card__bar">
        <div className="stage-card__bar-track">
          <div
            className="stage-card__bar-fill"
            style={{ width: `${score}%`, background: toneColor }}
          />
        </div>
        <div className="stage-card__bar-meta">
          <span>
            {score}
            <span className="stage-card__bar-meta-dim">/100</span>
          </span>
          <span className="stage-card__bar-meta-dim">WEIGHT {weight}%</span>
        </div>
      </div>

      <dl className="stage-card__data">
        {rows.map(([k, v]) => (
          <div key={k} className="stage-card__row">
            <dt className="stage-card__key">{k}</dt>
            <dd className="stage-card__val">{v}</dd>
          </div>
        ))}
      </dl>

      <div className="stage-card__reasoning">
        <div className="stage-card__reasoning-label">{'// REASONING'}</div>
        <p className="stage-card__reasoning-text">{reasoning}</p>
      </div>
    </article>
  );
}
